import { notifyHashtagsChanged } from "@/lib/hashtag-events";
import { ElectronStorageAdapter } from "../adapters/electron.adapter";
import { BaseRepository } from "../base.repository";
import { type Hashtag, type IHashtagRepository } from "../entities/hashtag";

export class HashtagsRepository extends BaseRepository<Hashtag> implements IHashtagRepository {
    constructor() {
        super(new ElectronStorageAdapter(), "hashtags");
    }

    async findByHashtag(tag: string): Promise<Hashtag[]> {
        const all = await this.getAll();
        return all.filter((h) => h.hashtag === tag);
    }

    async sync(filename: string, tags: string[]): Promise<void> {
        await window.electronAPI.db.hashtags.sync(filename, tags);
        notifyHashtagsChanged();
    }
}
